import React from "react";
import {
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { useField } from "formik";

//App
import { TextFieldProps } from "../../../../types";

const NumericTextField: React.FC<TextFieldProps> = ({
  label,
  name,
  isRequired,
  disabled,
  onChange,
  onBlur,
  decimalPlace = 2,
  isDollar,
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, value, ...fieldProps } = field;

  const [isFocused, setIsFocused] = React.useState(false);
  const [rawValue, setRawValue] = React.useState(field.value);
  const inputRef = React.useRef(null);
  const localValue = isFocused
    ? rawValue
    : decimalPlace
    ? parseFloat(field?.value ?? 0)?.toFixed(decimalPlace)
    : field.value;

  const handleChange = (e: any) => {
    if (e.target.value < 0) setRawValue(0);
    else {
      if (isNaN(e.nativeEvent.data)) {
        e.preventDefault();
      } else {
        setRawValue(e.target.value);
        field.onChange(e);
        if (onChange) onChange(e);
      }
    }
  };

  const configTextField = {
    ...field,
    value: localValue,
  };

  React.useEffect(() => {
    setRawValue(field.value);
  }, [field.value]);

  const handleFocus = (event: any) => {
    setIsFocused(true);
    setTimeout(() => {
      const input: any = inputRef.current;
      if (input) {
        input.selectionStart = 0;
        if (isDollar && input?.value === 0) input.selectionEnd = 1;
        else input.selectionEnd = 0;
      }
    }, 0);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "." && decimalPlace === 0) {
      event.preventDefault();
    }
  };

  const handleBlur = (event: any) => {
    setIsFocused(false);
    let newValue = parseFloat(event.target.value);

    field.onChange({
      target: {
        name: event.target.name,
        value: newValue,
      },
    });
    if (onBlur) onBlur(event);
  };

  return (
    <FormGroup floating>
      <InputGroup>
        {isDollar && <InputGroupText>$</InputGroupText>}
        <Input
          type={"number"}
          {...fieldProps}
          {...configTextField}
          ref={inputRef}
          id={name}
          name={name}
          placeholder={label}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={meta?.touched && !!meta?.error}
          disabled={disabled}
        />
        {!isDollar && (
          <Label for={name}>{isRequired ? `${label} *` : label}</Label>
        )}
        {meta?.touched && meta?.error && (
          <FormFeedback>{meta?.error}</FormFeedback>
        )}
      </InputGroup>
    </FormGroup>
  );
};

export default NumericTextField;
